
namespace Gamification.Gamification {

    enum AmbitoEnum {
        Indefinito = 0,
        VisualizzaChecklist = 1,
        VisualizzaRisorse = 2
    }

    @Serenity.Decorators.registerEditor('Gamification.Gamification.RisorseChecklist2Editor')
    export class RisorseChecklist2Editor extends Serenity.EntityGrid<RisorseChecklistRow, any> {
        protected getColumnsKey() { return RisorseChecklistColumns.columnsKey; }
        protected getDialogType() { return RisorseChecklistDialog; }
        protected getIdProperty() { return RisorseChecklistRow.idProperty; }
        protected getInsertPermission() { return RisorseChecklistRow.insertPermission; }
        protected getLocalTextPrefix() { return RisorseChecklistRow.localTextPrefix; }
        protected getService() { return RisorseChecklistService.baseUrl; }

        static AmbitoEnum = AmbitoEnum;

        constructor(container: JQuery) {
            super(container);
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }

        protected getInitialTitle() {
            return null;
        }

        protected usePager() {
            return true;
        }

        protected createQuickSearchInput() { }

        protected getGridCanLoad() {
            return this.idRisorsa != null || this.idChecklist != null;
        }

        protected getColumns() {
            var columns = super.getColumns();

            // Add column
            columns.unshift({
                field: 'Edit Row',
                name: '',
                format: ctx => '<a class="inline-action edit-row" title="Associa sostanze">' +
                    '<i class="fa fa-wrench text-blue"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            // Add column
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            // Remove Button
            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);

            //Add a Button
            buttons.push({
                title: 'Seleziona',
                hint: '',
                cssClass: 'goto-seleziona',
                icon: 'fa-list-ol',
                separator: true,
                onClick: () => { /*Add Function Here */
                    if (this.ambito == AmbitoEnum.VisualizzaChecklist) {
                        //
                        var checklistPickerDialog = new ChecklistPickerDialog({
                            hideChecklist: this.view.getItems().map(x => x.IdRisorsa)
                        });
                        //
                        checklistPickerDialog.onSuccess = (selected) => {
                            // filter already existing products
                            selected = selected.filter(x => !Q.any(this.view.getItems(), y => y.IdChecklist == x.IdChecklist));

                            for (var sel of selected) {
                                var item = <RisorseChecklistRow>{
                                    IdRisorsa: this.idRisorsa,
                                    IdChecklist: sel.IdChecklist
                                    //,FaseTitolo: sel.Titolo
                                };
                            }
                            RisorseChecklistService.Create({
                                Entity: item
                            },
                                response => {
                                    this.view.addItem({
                                        IdRisorsaChecklist: response.EntityId,
                                        IdRisorsa: this.idRisorsa,
                                        IdChecklist: sel.IdChecklist,
                                        IdRisorsaNome: sel.Nome
                                    });
                                    //
                                    this.refresh();
                                },
                                {
                                    async: false
                                });

                            return true;
                        };
                        //
                        risorsePickerDialog.dialogOpen();
                    }
                    if (this.ambito == AmbitoEnum.VisualizzaRisorse) {

                        var risorsePickerDialog = new RisorsePickerDialog({
                            hideRisorse: this.view.getItems().map(x => x.IdChecklist)
                        });

                        risorsePickerDialog.onSuccess = (selected) => {
                            selected = selected.filter(x => !Q.any(this.view.getItems(), y => y.IdRisorsa == x.IdRisorsa));

                            for (var sel of selected) {
                                var item = <RisorseChecklistRow>{
                                    IdChecklist: this.idChecklist,
                                    IdRisorsa: sel.IdRisorsa,
                                    IdRisorsaNome: sel.Nome
                                };

                                RisorseChecklistService.Create({
                                    Entity: item
                                },
                                    response => {
                                        this.view.addItem({
                                            IdRisorsaChecklist: response.EntityId,
                                            IdChecklist: this.idChecklist,
                                            IdRisorsa: sel.IdRisorsa,
                                            IdRisorsaNome: sel.Nome
                                        });
                                        //
                                        this.refresh();
                                    },
                                    {
                                        async: false
                                    });
                            }

                            return true;
                        };

                        risorsePickerDialog.dialogOpen();
                    }
                }
            });

            //
            return buttons;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented())
                return;

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Desideri eliminare il record selezionato?', () => {
                        RisorseChecklistService.Delete({
                            EntityId: item.IdRisorsaChecklist
                        },
                            response => {
                                this.view.deleteItem(item.IdRisorsaChecklist);
                                this.refresh();
                            },
                            { async: false });
                    });
                }

                if (target.hasClass("checklist-link")) {
                    e.preventDefault();
                    //
                    new Gamification.ChecklistDialog().loadByIdAndOpenDialog(item.IdChecklist);
                }
                else if (target.hasClass("Risorsa-link")) {
                    e.preventDefault();
                    //
                    new Gamification.RisorseDialog().loadByIdAndOpenDialog(item.IdRisorsa);
                }
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        private _ambito: AmbitoEnum = AmbitoEnum.Indefinito;
        private _idRisorsa: number;
        private _idChecklist: number;

        // +++++++++++++++++++++++++++++++++++++++++++
        get ambito() {
            return this._ambito;
        }

        set ambito(value: AmbitoEnum) {
            if (this._ambito != value) {
                this._ambito = value;

                if (this._ambito == AmbitoEnum.VisualizzaChecklist) {
                    var columns = this.slickGrid.getColumns();

                    //var nIndice = Q.indexOf(columns, x => x.field == RisorseChecklistRow.Fields.IdChecklistNome);
                    //columns.splice(nIndice, 1);

                    //nIndice = Q.indexOf(columns, x => x.field == RisorseChecklistRow.Fields.UnitaNome);
                    //columns.splice(nIndice, 1);

                    this.slickGrid.setColumns(columns);
                }

                if (this._ambito == AmbitoEnum.VisualizzaRisorse) {
                    var columns = this.slickGrid.getColumns();

                    //var nIndice = Q.indexOf(columns, x => x.field == RisorseChecklistRow.Fields.IdRisorsaTitolo);
                    //columns.splice(nIndice, 1);

                    this.slickGrid.setColumns(columns);
                }
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        get idChecklist() {
            return this._idChecklist;
        }

        set idChecklist(value: number) {
            if (this._idChecklist != value) {
                this._idChecklist = value;
                this.setEquality(RisorseChecklistRow.Fields.IdChecklist, value);
                this.refresh();
            }
        }

        // +++++++++++++++++++++++++++++++++++++++++++
        get idRisorsa() {
            return this._idRisorsa;
        }

        set idRisorsa(value: number) {
            if (this._idRisorsa != value) {
                this._idRisorsa = value;
                this.setEquality(RisorseChecklistRow.Fields.IdRisorsa, value);
                this.refresh();
            }
        }
    }
}